const route = url => `{
    route(url: "${url}") {
        ... on CmsPage {
            title
            content
        }
    }
}`;

export default {
    route,
};
